import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {//首页
      path: '/',
      name: 'index',
      meta: { title: "第三方平台授权" },
      component: () => import('./views/pc.vue')
    },
    {//首页
      path: '/mobileTerminal',
      name: 'mobileTerminal',
      meta: { title: "第三方平台授权" },
      component: () => import('./views/mobileTerminal.vue')
    },
  ]
})
